import { PrintServiceProductEntityHydrated } from "@jackfruit/common"
import { groupBy } from "lodash"

export const groupProductsByGroup = (
  products: PrintServiceProductEntityHydrated[],
  shouldGroup: boolean
): {
  groups: Record<string, PrintServiceProductEntityHydrated[]>
  groupKeys: string[]
} => {
  if (!shouldGroup) {
    return {
      groups: { "": products },
      groupKeys: [""],
    }
  } else {
    const collator = new Intl.Collator(undefined, {
      numeric: true,
      sensitivity: "base",
    })

    const groupedProducts = groupBy(products, "group")

    const sortedGroup = Object.keys(groupedProducts).sort(collator.compare)

    // empty groups always goes at the end
    const emptyGroupIndex = sortedGroup.findIndex(group => group === "")
    if (emptyGroupIndex > -1) {
      const emptyGroup = sortedGroup.splice(emptyGroupIndex, 1)[0]
      sortedGroup.push(emptyGroup)
    }

    return {
      groups: groupedProducts,
      groupKeys: sortedGroup,
    }
  }
}
